import { useEffect } from "react";

import styles from "./PrivacyStatementPage.module.scss";

export const PrivacyStatementPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.about}>
      <div className={styles.title}>Obavijest o privatnosti</div>
      <p className={styles.paragraph}>
        Putem ove obavijesti želimo vas informirati na koji način se prikupljaju
        i obrađuju vaši osobni podaci u sklopu Nacionalnog informacijskog
        sustava upisa u osnovne škole (e-OŠ). Škole su na razini svoje ustanove
        voditelji obrade, a Ministarstvo znanosti, obrazovanja i mladih na
        razini cijelog sustava obrazovanja u osnovnim školama. CARNET je
        izvršitelj obrade osobnih podataka. Izvršitelj obrade je i županijski
        upravni odjel/gradski ured nadležan za poslove upisa u osnovne škole na
        razini svake županije.
      </p>

      <div className={styles.subtitle}>Podaci koji se prikupljaju</div>
      <p className={styles.paragraph}>
        Nacionalni informacijski sustav upisa u osnovne škole prikuplja osobne
        podatke školskih obveznika, njihovih roditelja/skrbnika, ravnatelja,
        školskih administratora, članova stručnih povjerenstava osnovnih škola
        i stručnih povjerenstava Upravnih odjela radi provođenja postupka upisa
        djece u prvi razred osnovne škole. Proces je propisan Zakonom o odgoju i
        obrazovanju u osnovnoj i srednjoj školi (NN 87/08, 86/09, 92/10, 105/10,
        90/11, 5/12, 16/12, 86/12, 126/12, 94/13, 152/14, 07/17, 68/18, 98/19,
        64/20, 151/22, 155/23 i 156/23) te Pravilnikom o postupku utvrđivanja
        psihofizičkog stanja djeteta, učenika te sastavu stručnih povjerenstava
        (NN 67/14, 63/20).
      </p>
      <p className={styles.paragraph}>
        Škole kao voditelji obrade za svoju ustanovu, prilikom provođenja
        procesa upisa djece u prvi razred osnovne škole putem Nacionalnog
        informacijskog sustava upisa u osnovne škole, prikupljaju sljedeće
        osobne podatke iz povezanih registara (e-Matica, OIB registar, matične
        knjige, MUP registar) ili direktno od korisnika:
      </p>
      <ul>
        <li>
          Osobni podaci djece (školskih obveznika i kandidata za prijevremeni
          upis): ime i prezime, OIB, datum rođenja, spol, mjesto rođenja,
          država rođenja, državljanstvo, nacionalna manjina, nacionalnost,
          podaci o prebivalištu/boravištu
        </li>
        <li>
          Osobni podaci djelatnika škole i ŽUO/GU (članova stručnih
          povjerenstava, administratora, ravnatelja, čelnika): ime i prezime,
          OIB, broj telefona/mobitela, e-mail
        </li>
        <li>
          Osobni podaci roditelja/skrbnika: ime i prezime, OIB, datum rođenja,
          spol, mjesto rođenja, država rođenja, državljanstvo, nacionalna
          manjina, nacionalnost, odnos prema djetetu, stručna sprema, zanimanje,
          broj telefona/mobitela, e-mail, podaci o prebivalištu/boravištu
        </li>
        <li>
          Osjetljivi podaci vezani uz proces utvrđivanja psihofizičkog stanja
          djeteta (razvojna razina djeteta, kakve teškoće u razvoju ima i sl.)
        </li>
        <li>
          Obrazovni podaci upisanih školskih obveznika (obrazovni program,
          ustanova i razredni odjel koji dijete upisuje)
        </li>
        <li>
          Učitani dokumenti od strane roditelja (dokumenti koje je roditelj
          učitao prilikom predaje zahtjeva za upis (medicinska (specijalistička)
          dokumentacija, psihološka dokumentacija,
          edukacijsko-rehabilitacijska dokumentacija, mišljenje stručnog tima
          predškolske ustanove o psihofizičkom stanju djeteta, dokumentacija
          jedinstvenog tijela vještačenja, dokumentacija roditelja (npr. dokaz
          o roditeljstvu za drugog roditelja), dokumentacija djeteta...)
        </li>
        <li>
          Učitani dokumenti nastali kao rezultat upisnog procesa (dokumenti koje
          je učitao administrator ŽUO (rješenje o primjerenom programu,
          rješenje o odgodi upisa, rješenje o privremenom oslobađanju od
          upisa...)
        </li>
      </ul>
      <p className={styles.paragraph}>
        Svi osobni podaci koriste se isključivo u svrhe radi koje su
        prikupljeni.
      </p>

      <div className={styles.subtitle}>
        Razdoblje u kojem će osobni podaci biti pohranjeni
      </div>
      <p className={styles.paragraph}>
        Sukladno Pravilniku o pedagoškoj dokumentaciji i evidenciji te javnim
        ispravama u školskim ustanovama (NN 98/2024), osobni podaci učenika,
        djelatnika i roditelja se ne brišu.
      </p>
      <p className={styles.paragraph}>Logovi o aktivnosti korisnika se trajno čuvaju.</p>

      <div className={styles.subtitle}>Prenošenje vaših osobnih podataka</div>
      <p className={styles.paragraph}>
        Prikupljeni podaci neće se prenositi u treće zemlje niti međunarodne
        organizacije niti na koji način biti dostupni trećim osobama, osim u
        slučaju kada je takva obaveza regulirana zakonom ili temeljem odluke
        voditelja obrade.
      </p>

      <div className={styles.subtitle}>
        Pristup i ažuriranje vaših osobnih podataka
      </div>
      <p className={styles.paragraph}>
        Korisnik u svakom trenutku ima sljedeća prava u opsegu u kojem je to
        primjenjivo:
      </p>
      <ul>
        <li>pravo na pristup podacima i uvid u podatke</li>
        <li>pravo na informiranost o obradi osobnih podataka</li>
        <li>pravo na prenosivost podataka</li>
        <li>pravo na podnošenje prigovora</li>
        <li>
          pravo na ispravak i promjenu osobnih podataka u slučaju ako su podaci
          nepotpuni ili netočni
        </li>
      </ul>

      <div className={styles.subtitle}>Sigurnost vaših osobnih podataka</div>
      <p className={styles.paragraph}>
        Poduzimaju se sve tehničke i organizacijske mjere sigurnosti kako bi se
        zaštitili vaši osobni podaci od neovlaštenog ili nezakonitog postupanja
        s njima i od njihovog slučajnog gubitka, uništenja ili izmjena.
      </p>

      <div className={styles.subtitle}>
        Kontaktni podaci službenika za zaštitu podataka
      </div>
      <p className={styles.paragraph}>
        Za obrade koje provodi škola obratite se službeniku za zaštitu podataka
        relevantne škole. Ministarstvo znanosti, obrazovanja i mladih je
        sukladno relevantnim propisima imenovalo službenika za zaštitu podataka
        kojega možete kontaktirati prema podacima na web adresi{" "}
        <a
          href="https://mzom.gov.hr/pristup-informacijama/zastita-osobnih-podataka/482"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://mzom.gov.hr/pristup-informacijama/zastita-osobnih-podataka/482
        </a>{" "}
        za sva pitanja povezana s obradom vaših osobnih podataka ili
        ostvarivanje svojih prava na zaštitu osobnih podataka za obrade koje
        provodi Ministarstvo znanosti, obrazovanja i mladih.
      </p>

      <div className={styles.subtitle}>Nadzorno tijelo</div>
      <p className={styles.paragraph}>
        Ako imate prigovor vezano uz vlastita prava možete uputiti primjedbu
        nadzornom tijelu za zaštitu osobnih podataka, odnosno Agenciji za zaštitu
        osobnih podataka (AZOP).
      </p>
      <p className={styles.paragraph}>
        Agencija za zaštitu osobnih podataka
        <br />
        <a href="https://azop.hr/" target="_blank" rel="noopener noreferrer">
          https://azop.hr/
        </a>
      </p>
    </div>
  );
};
